import { render, staticRenderFns } from "./safetys.vue?vue&type=template&id=b8b0ba00&scoped=true&"
import script from "./safetys.vue?vue&type=script&lang=js&"
export * from "./safetys.vue?vue&type=script&lang=js&"
import style0 from "./safetys.vue?vue&type=style&index=0&id=b8b0ba00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b0ba00",
  null
  
)

export default component.exports